import React from 'react';
import Styled from 'styled-components';
import { Trans } from '@lingui/react';
import TimeoutIcon from '@assets/TimeoutClockIcon';
import CookieManager from '@lib/CookieManager';
import { useRouter } from 'next/router';
import { EVENT_VISIT_DATE_COOKIE } from '@lib/constants';
import { Button } from '@components/ButtonV2';

const Content = Styled.div`
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 100vw;
  color: white;
  text-align: center;
  background-color: rgba(36, 50, 64, .9);
  z-index: 99;


  p {
    max-width: 640px;
    font-size: 16px;
    padding: 20px;
    margin: 15px 0;
  }
`;

const LiveReserveTimeoutOverlay = () => {
  const router = useRouter();
  const { lang, slug } = router.query;

  const handleClick = () => {
    CookieManager.remove({ key: EVENT_VISIT_DATE_COOKIE });
  };

  return (
    <Content>
      <TimeoutIcon />
      <p>
        <Trans id="live.payment_page.countdown_timeout_desc" />
      </p>
      <Button
        appearance="white"
        href={`/${lang}/live/${slug}`}
        onClick={handleClick}
      >
        <Trans id="live.payment_page.countdown_timeout_btn" />
      </Button>
    </Content>
  );
};

export default LiveReserveTimeoutOverlay;
